import $ from 'jquery'
window.$ = window.jQuery = $
import 'slick-carousel'

(function($){

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {

    // let $eventsSlider = $block.find('.events-slider')

    // $eventsSlider.not('.slick-initialized').slick({
    //   slidesToShow: 5,
    //   slidesToScroll: 5,
    //   dots: false,
    //   arrows: true,
    //   infinite: false,
    //   prevArrow: '.event-arrow.prev-arrow',
    //   nextArrow: '.event-arrow.next-arrow',
    //   responsive: [
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 576,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // })
  }

  // Initialize each block on page load (front end).
  $(function(){
      $('.events-block').each(function(){
          initializeBlock( $(this) );
      });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
      window.acf.addAction( 'render_block_preview/type=events-block-section', initializeBlock );
  }

})(jQuery);
